import {CHANGE_VIEW} from 'src/shared/currentView/actions';
import {createLoggerMiddleware} from 'src/shared/logger/middleware';

export const logger = createLoggerMiddleware({
  component: 'XHS-PAGE-REPORT-ISSUE',
  page: 'reportIssue',
  typesWithValues: [
    CHANGE_VIEW,
  ],
});
